export const GET_REASON_REQUEST = "GET_REASON_REQUEST";
export const GET_REASON_RESPONSE = "GET_REASON_RESPONSE";

export const GET_SINGLE_REASON_REQUEST = "GET_SINGLE_REASON_REQUEST";
export const GET_SINGLE_REASON_RESPONSE = "GET_SINGLE_REASON_RESPONSE";

export const UPDATE_REASON_REQUEST = "UPDATE_REASON_REQUEST";
export const UPDATE_REASON_RESPONSE = "UPDATE_REASON_RESPONSE";
